/** Pilares de servicio: nav, home, /servicios, footer y tarjeta. */
export const SERVICE_PILLARS = [
  {
    id: 'vulpin',
    title: 'Vulpin Suite',
    short:
        'ERP modular en producción (~40 organizaciones): Business, Social, Care, Corps y Teams. La gestión repetida y el OCR van dentro del producto.',
    navDesc: 'ERP modular para pymes y entidades sociosanitarias',
    href: '/vulpin',
    features: ['Business · Social · Care', 'Teams · portal empleados', 'Datos sensibles'],
  },
  {
    id: 'ciberseguridad',
    title: 'Ciberseguridad y Cumplimiento',
    short:
      'RGPD y AI Act cuando hay datos de menores, dependencia o salud: accesos, copias restaurables y concienciación del equipo.',
    navDesc: 'Datos sensibles, RGPD y AI Act',
    href: '/servicios/ciberseguridad-cumplimiento',
    features: ['Auditoría', 'Accesos y copias', 'RGPD · AI Act'],
  },
  {
    id: 'ia-produccion',
    title: 'IA en Producción',
    short:
      'El prototipo en ChatGPT, Cursor o no-code no es un producto: backend, API, Azure y un mantenimiento con responsable.',
    navDesc: 'De prototipo a backend, API y Azure',
    href: '/servicios/ia-en-produccion',
    features: ['Auditoría de despliegue', 'Precio cerrado', 'Retainer'],
  },
  {
    id: 'web-ecommerce',
    title: 'Desarrollo Web y E-commerce',
    short:
      'Web o tienda que habla con el ERP y el inventario. No una landing que se queda desactualizada a la semana.',
    navDesc: 'Web y tienda conectadas al ERP',
    href: '/servicios/desarrollo-web-ecommerce',
    features: ['Web a medida', 'Ecommerce', 'Conectada al ERP'],
  },
  {
    id: 'microsoft-azure',
    title: 'Consultoría Microsoft / Azure / Google Workspace',
    short:
      'Equipo tecnológico externo: cuentas (365 / Workspace), infraestructura de proyectos en Azure o AWS, y operación. Roadmap Solutions Partner en curso.',
    navDesc: 'Equipo IT externo · 365 · Azure · AWS',
    href: '/servicios/consultoria-microsoft-azure',
    features: ['365 · Workspace', 'Infra de proyectos', 'Equipo IT externo'],
  },
  {
    id: 'ingenieria-cuota',
    title: 'Ingeniería a cuota',
    short:
      'Un ingeniero en tu empresa, con la consultora detrás: desarrollo a medida y acompañamiento en la digitalización por una cuota mensual.',
    navDesc: 'Ingeniero externo · desarrollo y digitalización',
    href: '/servicios/ingenieria-a-cuota',
    features: ['Cuota mensual', 'Desarrollo en la gestión', 'Sin plantilla'],
  },
];
